import { render, staticRenderFns } from "./goal_list_layout.vue?vue&type=template&id=fb020262&"
import script from "./goal_list_layout.vue?vue&type=script&lang=js&"
export * from "./goal_list_layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports